import Avatar from 'components/Avatar';
import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { LoginAction, UIAction } from 'redux/actions';


import {
  MdClearAll,
  MdExitToApp,
  MdVpnKey,
} from 'react-icons/md';
import {
  Button,
  ListGroup,
  ListGroupItem,
  Nav,
  Navbar,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
} from 'reactstrap';
import bn from 'utils/bemnames';
import AlertMessage from 'components/AlertMessage';


const bem = bn.create('header');
class Header extends React.Component {

  

  state = {
    isOpenNotificationPopover: false,
    isOpenUserCardPopover: false,
    isLoading: false,
  };


  toggleNotificationPopover = () => {
    this.setState({
      isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
    });

    if (!this.state.isNotificationConfirmed) {
      this.setState({ isNotificationConfirmed: true });
    }
  };

  toggleUserCardPopover = () => {
    this.setState({
      isOpenUserCardPopover: !this.state.isOpenUserCardPopover,
    });
  };

  handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();
    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };


  componentWillMount() {
    this.props.getLoginData();
  }



  handleUpdate = () => {


    this.props.showLoading(true)

    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
    caches.keys().then((keyList) => {
      return Promise.all(
        keyList.map((key) => {
          return caches.delete(key);
        })
      );
    });
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

  async handleRefreshClick() {
    caches.keys().then((keyList) => {
      return Promise.all(
        keyList.map((key) => {
          return caches.delete(key);
        })
      );
    });
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }



  render() {
    
    const loginData = this.props.loginData;
    return (
      <>
        
        <AlertMessage top={true} />
        <Navbar light expand className={bem.b('bg-white')}>
          <Nav navbar className="mr-2">
            <Button color="primary" outline onClick={this.handleSidebarControlButton}>
              <MdClearAll size={25} />
            </Button>
          </Nav>
          <Nav navbar className={bem.e('nav-right')}>
            <NavItem>
              <NavLink id="Popover2">
                <span className='user-name-span'>{(loginData && loginData.name) ? loginData.name : ''}</span>
                <Avatar
                  onClick={this.toggleUserCardPopover}
                  className="can-click logedin-user-img" size={40}
                />
              </NavLink>
              
              <Popover
                placement="bottom-end"
                isOpen={this.state.isOpenUserCardPopover}
                onClick={this.toggleUserCardPopover}
                //toggle={this.toggleUserCardPopover}
                target="Popover2"
                className="p-0 border-0"
                style={{ minWidth: 250 }}
              >
                <PopoverBody className="p-0 border-light header-popover">
                  <ListGroup flush>
                    <ListGroupItem tag="button" action className="border-light">
                      <Link onClick={this.toggleUserCardPopover} to="/change-password"> <MdVpnKey /> Change Password</Link>
                    </ListGroupItem>
                    <ListGroupItem tag="button" action className="border-light" onClick={this.navigate}>
                      <Link to="/logout"> <MdExitToApp /> Signout</Link>
                    </ListGroupItem>

                    <ListGroupItem tag="button" action className="border-light">
                      <Button color="primary"
                        style={{ padding: 'auto' }}
                        size="sm"
                        onClick={this.handleUpdate} >Check for Updates</Button>
                    </ListGroupItem>


                  </ListGroup>
                </PopoverBody>
              </Popover>
            </NavItem>
          </Nav>

        </Navbar>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
});

const mapDispatchToProps = (dispatch) => ({
  getLoginData: (payload) => dispatch(LoginAction.getLoginData(payload)),
  showLoading: (isLoading) => dispatch(UIAction.showMainLoading(isLoading)),
  
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);

